class BonkersPremiumHeader extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-bph-open]');
    this.closeButtons = this.querySelectorAll('[data-bph-close]');
    this.drawer = this.querySelector('.bph-drawer');
    this.disclosures = this.querySelectorAll('[data-bph-disclosure]');
    this.megaItems = Array.from(this.querySelectorAll('[data-bph-mega-item]'));
    this.megaOverlay = this.querySelector('[data-bph-mega-overlay]');
    this.megaOpenOn = this.dataset.megaOpenOn === 'click' ? 'click' : 'hover';
    this.isTransparent = this.dataset.transparent === 'true';
    this.solidOnScroll = this.dataset.transparentSolidOnScroll !== 'false';
    this.megaCloseTimer = null;
    this.drawerTabs = Array.from(this.querySelectorAll('[data-bph-tab]'));
    this.drawerPanes = Array.from(this.querySelectorAll('[data-bph-pane]'));
    this.drawerSubs = Array.from(this.querySelectorAll('[data-bph-sub]'));
    this.drawerSubOpeners = Array.from(this.querySelectorAll('[data-bph-sub-open]'));
    this.drawerSubClosers = Array.from(this.querySelectorAll('[data-bph-sub-close]'));
    this.drawerBody = this.querySelector('[data-bph-drawer-body]');
    this.searchOpenButtons = this.querySelectorAll('[data-bph-search-open]');
    this.searchCloseButtons = this.querySelectorAll('[data-bph-search-close]');
    this.searchDrawer = this.querySelector('.bph-search-drawer');
    this.searchInput = this.querySelector('[data-bph-search-input]');
    this.cartOpenButtons = this.querySelectorAll('[data-bph-cart-open]');
    this.cartCloseButtons = this.querySelectorAll('[data-bph-cart-close]');
    this.cartDrawer = this.querySelector('.bph-cart-drawer');
    this.cartBody = this.querySelector('[data-bph-cart-body]');
    this.cartFooter = this.querySelector('[data-bph-cart-footer]');
    this.cartExtras = this.querySelector('[data-bph-cart-extras]');
    this.cartTitleCount = this.querySelector('[data-bph-cart-title-count]');
    this.cartCountElements = this.querySelectorAll('[data-bph-cart-count]');
    this.shippingProgress = this.querySelector('[data-bph-shipping-progress]');
    this.shippingMessage = this.querySelector('[data-bph-shipping-message]');
    this.shippingFill = this.querySelector('[data-bph-shipping-fill]');
    this.shippingCar = this.querySelector('[data-bph-shipping-car]');
    this.freeShippingThreshold = Number(this.dataset.freeShippingThreshold || 129900);
    this.stickyType = this.dataset.stickyType || 'none';
    this.lastScrollY = window.scrollY;
    this.scrollTicking = false;
    this.cartCurrency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    this.cartEvents = ['bonkers:cart-refresh', 'cart:updated', 'cart:refresh', 'product:added', 'ajaxProduct:added', 'cartUpdate'];

    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.openSearchDrawer = this.openSearchDrawer.bind(this);
    this.closeSearchDrawer = this.closeSearchDrawer.bind(this);
    this.openCartDrawer = this.openCartDrawer.bind(this);
    this.closeCartDrawer = this.closeCartDrawer.bind(this);
    this.onCartActionClick = this.onCartActionClick.bind(this);
    this.onCartActionSubmit = this.onCartActionSubmit.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.setHeaderHeight.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onCartRefresh = this.refreshCartCount.bind(this);

    if (this.openButton) {
      this.openButton.addEventListener('click', this.openDrawer);
    }

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.closeDrawer);
    });

    this.searchOpenButtons.forEach((button) => {
      button.addEventListener('click', this.openSearchDrawer);
    });

    this.searchCloseButtons.forEach((button) => {
      button.addEventListener('click', this.closeSearchDrawer);
    });

    this.cartOpenButtons.forEach((button) => {
      button.addEventListener('click', this.openCartDrawer);
    });

    this.cartCloseButtons.forEach((button) => {
      button.addEventListener('click', this.closeCartDrawer);
    });

    this.addEventListener('click', this.onCartActionClick);
    this.addEventListener('submit', this.onCartActionSubmit);
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('click', this.onDocumentClick);
    this.cartEvents.forEach((eventName) => document.addEventListener(eventName, this.onCartRefresh));
    this.installCartHooks();
    this.updateCartCount(Number(this.dataset.cartCount || 0));
    this.updateShippingProgress(Number(this.dataset.cartTotal || 0));
    this.startSearchTypewriter();
    this.initMegaMenu();
    this.initDrawerNav();
    this.updateTransparentState();

    if (this.stickyType !== 'none') {
      this.classList.add('is-sticky');
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.setHeaderHeight();
      window.addEventListener('resize', this.onResize, { passive: true });
    }
  }

  disconnectedCallback() {
    if (this.openButton) {
      this.openButton.removeEventListener('click', this.openDrawer);
    }

    this.closeButtons.forEach((button) => {
      button.removeEventListener('click', this.closeDrawer);
    });

    this.searchOpenButtons.forEach((button) => {
      button.removeEventListener('click', this.openSearchDrawer);
    });

    this.searchCloseButtons.forEach((button) => {
      button.removeEventListener('click', this.closeSearchDrawer);
    });

    this.cartOpenButtons.forEach((button) => {
      button.removeEventListener('click', this.openCartDrawer);
    });

    this.cartCloseButtons.forEach((button) => {
      button.removeEventListener('click', this.closeCartDrawer);
    });

    this.removeEventListener('click', this.onCartActionClick);
    this.removeEventListener('submit', this.onCartActionSubmit);
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('click', this.onDocumentClick);
    this.cartEvents.forEach((eventName) => document.removeEventListener(eventName, this.onCartRefresh));
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.clearTimeout(this.searchTypewriterTimer);
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }

  startSearchTypewriter() {
    const inputs = Array.from(this.querySelectorAll('[data-bph-typewriter]'));
    const fallbackPlaceholder = this.dataset.searchPlaceholder || 'Search...';
    const terms = String(this.dataset.searchTypewriterTerms || '')
      .split(',')
      .map((term) => term.trim())
      .filter(Boolean);

    window.clearTimeout(this.searchTypewriterTimer);

    if (!inputs.length || !terms.length) {
      inputs.forEach((input) => {
        input.placeholder = fallbackPlaceholder;
      });
      return;
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      inputs.forEach((input) => {
        input.placeholder = terms[0];
      });
      return;
    }

    let termIndex = 0;
    let characterIndex = 0;
    let isDeleting = false;

    const updatePlaceholders = (value) => {
      inputs.forEach((input) => {
        input.placeholder = value;
      });
    };

    const typeNextCharacter = () => {
      if (!this.isConnected) return;

      const term = terms[termIndex];
      characterIndex += isDeleting ? -1 : 1;
      characterIndex = Math.max(0, Math.min(characterIndex, term.length));
      updatePlaceholders(characterIndex ? term.slice(0, characterIndex) : fallbackPlaceholder);

      let delay = isDeleting ? 45 : 85;

      if (!isDeleting && characterIndex === term.length) {
        isDeleting = true;
        delay = 1500;
      } else if (isDeleting && characterIndex === 0) {
        isDeleting = false;
        termIndex = (termIndex + 1) % terms.length;
        delay = 300;
      }

      this.searchTypewriterTimer = window.setTimeout(typeNextCharacter, delay);
    };

    updatePlaceholders(fallbackPlaceholder);
    this.searchTypewriterTimer = window.setTimeout(typeNextCharacter, 350);
  }

  openDrawer() {
    this.classList.remove('is-hidden');
    this.closeSearchDrawer();
    this.closeCartDrawer();
    this.classList.add('is-drawer-open');
    this.closeAllMegaMenus();
    this.updateTransparentState();
    document.documentElement.style.overflow = 'hidden';
    if (this.drawer) {
      this.drawer.setAttribute('aria-hidden', 'false');
    }
    if (this.openButton) {
      this.openButton.setAttribute('aria-expanded', 'true');
    }
  }

  closeDrawer() {
    this.classList.remove('is-drawer-open');
    this.updateTransparentState();
    this.closeDrawerSubs();
    if (!this.classList.contains('is-cart-open') && !this.classList.contains('is-search-open')) {
      document.documentElement.style.overflow = '';
    }
    if (this.drawer) {
      this.drawer.setAttribute('aria-hidden', 'true');
    }
    if (this.openButton) {
      this.openButton.setAttribute('aria-expanded', 'false');
    }
  }

  openSearchDrawer(event) {
    if (event) event.preventDefault();

    const sourceForm = event && event.target ? event.target.closest('form') : null;
    const sourceInput = sourceForm ? sourceForm.querySelector('input[name="q"]') : null;

    if (sourceInput && this.searchInput && sourceInput !== this.searchInput) {
      this.searchInput.value = sourceInput.value;
    }

    this.classList.remove('is-hidden');
    this.closeDrawer();
    this.closeCartDrawer();
    this.classList.add('is-search-open');
    this.closeAllMegaMenus();
    this.updateTransparentState();
    document.documentElement.style.overflow = 'hidden';

    if (this.searchDrawer) {
      this.searchDrawer.setAttribute('aria-hidden', 'false');
    }

    this.searchOpenButtons.forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }, 180);
  }

  closeSearchDrawer() {
    this.classList.remove('is-search-open');
    this.updateTransparentState();
    if (!this.classList.contains('is-drawer-open') && !this.classList.contains('is-cart-open')) {
      document.documentElement.style.overflow = '';
    }

    if (this.searchDrawer) {
      this.searchDrawer.setAttribute('aria-hidden', 'true');
    }

    this.searchOpenButtons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  openCartDrawer(event) {
    if (event) event.preventDefault();

    this.classList.remove('is-hidden');
    this.closeDrawer();
    this.closeSearchDrawer();
    this.classList.add('is-cart-open');
    this.closeAllMegaMenus();
    this.updateTransparentState();
    document.documentElement.style.overflow = 'hidden';

    if (this.cartDrawer) {
      this.cartDrawer.setAttribute('aria-hidden', 'false');
    }

    this.cartOpenButtons.forEach((button) => {
      button.setAttribute('aria-expanded', 'true');
    });

    this.refreshCartCount();
  }

  closeCartDrawer() {
    this.classList.remove('is-cart-open');
    this.updateTransparentState();
    if (!this.classList.contains('is-drawer-open') && !this.classList.contains('is-search-open')) {
      document.documentElement.style.overflow = '';
    }

    if (this.cartDrawer) {
      this.cartDrawer.setAttribute('aria-hidden', 'true');
    }

    this.cartOpenButtons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  onKeyDown(event) {
    if (event.key === 'Escape') {
      this.closeDrawer();
      this.closeSearchDrawer();
      this.closeCartDrawer();
      this.closeDesktopDisclosures();
    }
  }

  onDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.closeDesktopDisclosures();
  }

  closeDesktopDisclosures() {
    this.disclosures.forEach((details) => details.removeAttribute('open'));
    this.closeAllMegaMenus();
  }

  /* ------------------------------------------------------------------ */
  /* Mobile drawer navigation                                            */
  /* ------------------------------------------------------------------ */

  initDrawerNav() {
    this.drawerTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.selectDrawerTab(tab.dataset.bphTab));

      // Arrow keys move between tabs, the way a tablist is expected to work.
      tab.addEventListener('keydown', (event) => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        const next = this.drawerTabs[(index + step + this.drawerTabs.length) % this.drawerTabs.length];
        if (!next) return;
        this.selectDrawerTab(next.dataset.bphTab);
        next.focus({ preventScroll: true });
      });
    });

    this.drawerSubOpeners.forEach((button) => {
      button.addEventListener('click', (event) => {
        // The row is an <a> so the category URL stays crawlable; with the
        // script running the tap opens the sub panel instead of navigating.
        event.preventDefault();
        this.openDrawerSub(button.dataset.bphSubOpen, button);
      });
    });

    this.drawerSubClosers.forEach((button) => {
      button.addEventListener('click', () => this.closeDrawerSubs());
    });

    // Open on whichever tab owns the page you are already looking at.
    const activeIndex = this.drawerPanes.findIndex((pane) => pane.querySelector('[aria-current], .is-active'));
    if (activeIndex > -1) this.selectDrawerTab(this.drawerPanes[activeIndex].dataset.bphPane);
  }

  selectDrawerTab(index) {
    if (!index) return;
    this.closeDrawerSubs();

    this.drawerTabs.forEach((tab) => {
      const on = tab.dataset.bphTab === String(index);
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
    });

    this.drawerPanes.forEach((pane) => {
      if (pane.dataset.bphPane === String(index)) pane.removeAttribute('hidden');
      else pane.setAttribute('hidden', '');
    });

    if (this.drawerBody) this.drawerBody.scrollTop = 0;
  }

  openDrawerSub(id, trigger) {
    if (!id) return;
    this.closeDrawerSubs();

    const panel = this.drawerSubs.find((sub) => sub.dataset.bphSub === id);
    if (!panel) return;

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    const list = panel.querySelector('.bph-drawer-list');
    if (list) list.scrollTop = 0;

    const back = panel.querySelector('[data-bph-sub-close]');
    if (back) back.focus({ preventScroll: true });
  }

  closeDrawerSubs() {
    if (!this.drawerSubs || !this.drawerSubs.length) return;
    this.drawerSubs.forEach((sub) => {
      sub.classList.remove('is-open');
      sub.setAttribute('aria-hidden', 'true');
    });
    this.drawerSubOpeners.forEach((button) => button.setAttribute('aria-expanded', 'false'));
  }

  /* ------------------------------------------------------------------ */
  /* Mega menu                                                           */
  /* ------------------------------------------------------------------ */

  initMegaMenu() {
    if (!this.megaItems.length) return;

    this.megaItems.forEach((item) => {
      const trigger = item.querySelector('[data-bph-mega-trigger]');
      if (!trigger) return;

      if (this.megaOpenOn === 'hover') {
        item.addEventListener('mouseenter', () => {
          if (window.matchMedia('(max-width: 989px)').matches) return;
          this.cancelMegaClose();
          this.openMegaMenu(item);
        });

        item.addEventListener('mouseleave', () => {
          if (window.matchMedia('(max-width: 989px)').matches) return;
          this.scheduleMegaClose();
        });

        // Touch and pen users get a first-tap-opens, second-tap-follows link.
        trigger.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          if (item.classList.contains('is-open')) return;
          event.preventDefault();
          this.openMegaMenu(item);
        });
      } else {
        trigger.addEventListener('click', (event) => {
          if (window.matchMedia('(max-width: 989px)').matches) return;
          if (item.classList.contains('is-open')) return;
          event.preventDefault();
          this.openMegaMenu(item);
        });
      }

      // Keyboard support: opening on focus, closing when focus leaves the item.
      trigger.addEventListener('focus', () => this.openMegaMenu(item));
      item.addEventListener('focusout', (event) => {
        if (item.contains(event.relatedTarget)) return;
        this.closeMegaMenu(item);
      });
    });

    if (this.megaOverlay) {
      this.megaOverlay.addEventListener('mouseenter', () => this.closeAllMegaMenus());
      this.megaOverlay.addEventListener('click', () => this.closeAllMegaMenus());
    }
  }

  openMegaMenu(item) {
    this.cancelMegaClose();
    this.megaItems.forEach((other) => {
      if (other !== item) this.closeMegaMenu(other);
    });

    item.classList.add('is-open');
    const trigger = item.querySelector('[data-bph-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    this.classList.add('is-mega-open');
    this.updateTransparentState();
  }

  closeMegaMenu(item) {
    if (!item) return;
    item.classList.remove('is-open');
    const trigger = item.querySelector('[data-bph-mega-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (!this.megaItems.some((other) => other.classList.contains('is-open'))) {
      this.classList.remove('is-mega-open');
      this.updateTransparentState();
    }
  }

  closeAllMegaMenus() {
    this.cancelMegaClose();
    if (!this.megaItems || !this.megaItems.length) return;
    this.megaItems.forEach((item) => this.closeMegaMenu(item));
  }

  scheduleMegaClose() {
    this.cancelMegaClose();
    this.megaCloseTimer = window.setTimeout(() => this.closeAllMegaMenus(), 140);
  }

  cancelMegaClose() {
    if (this.megaCloseTimer) {
      window.clearTimeout(this.megaCloseTimer);
      this.megaCloseTimer = null;
    }
  }

  /* ------------------------------------------------------------------ */
  /* Transparent header                                                  */
  /* ------------------------------------------------------------------ */

  updateTransparentState() {
    if (!this.isTransparent) return;

    const threshold = Math.max(this.offsetHeight - 8, 24);
    const scrolled = this.solidOnScroll && window.scrollY > threshold;
    const forced =
      this.classList.contains('is-mega-open') ||
      this.classList.contains('is-drawer-open') ||
      this.classList.contains('is-search-open');

    this.classList.toggle('is-solid', scrolled || forced);
  }

  getCartJsonUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return `${root}cart.js`;
  }

  getCartChangeUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return `${root}cart/change.js`;
  }

  updateCartCount(itemCount) {
    if (!this.cartCountElements.length) return;

    const count = Number(itemCount) || 0;
    const label = count > 99 ? '99+' : String(count);
    this.dataset.cartCount = String(count);

    this.cartCountElements.forEach((element) => {
      element.textContent = label;
    });

    if (this.cartTitleCount) {
      this.cartTitleCount.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
    }
  }

  refreshCartCount() {
    window.clearTimeout(this.cartRefreshTimer);
    this.cartRefreshTimer = window.setTimeout(() => {
      fetch(this.getCartJsonUrl(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && typeof cart.item_count === 'number') {
            this.updateCart(cart);
          }
        })
        .catch(() => {});
    }, 120);
  }

  updateCart(cart) {
    this.cartCurrency = cart.currency || this.cartCurrency;
    this.updateCartCount(cart.item_count);
    this.updateShippingProgress(cart.total_price);
    this.renderCartDrawer(cart);
  }

  updateShippingProgress(totalPrice) {
    if (!this.shippingProgress || !this.shippingMessage || !this.shippingFill) return;

    const threshold = Math.max(Number(this.freeShippingThreshold) || 129900, 1);
    const total = Math.max(Number(totalPrice) || 0, 0);
    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min((total / threshold) * 100, 100);

    this.dataset.cartTotal = String(total);
    this.shippingFill.style.width = `${progress}%`;
    if (this.shippingCar) {
      this.shippingCar.style.setProperty('--bph-shipping-progress', `${progress}%`);
    }

    if (remaining > 0) {
      this.shippingProgress.classList.remove('is-unlocked');
      this.shippingMessage.innerHTML = `Add <strong>${this.formatFreeShippingAmount(remaining)}</strong> more for free shipping`;
    } else {
      this.shippingProgress.classList.add('is-unlocked');
      this.shippingMessage.innerHTML = 'You have unlocked <strong>free shipping</strong>';
    }
  }

  formatFreeShippingAmount(cents) {
    const rupees = Math.ceil((Number(cents) || 0) / 100);
    return `Rs. ${rupees.toLocaleString('en-IN')}`;
  }

  renderCartDrawer(cart) {
    if (!this.cartBody || !this.cartFooter) return;

    const cartExtras = this.cartExtras;

    if (!cart.items || cart.items.length === 0) {
      this.cartBody.innerHTML = this.renderEmptyCart();
      if (cartExtras) {
        cartExtras.hidden = true;
        this.cartBody.appendChild(cartExtras);
      }
      this.cartFooter.innerHTML = `<a class="bph-cart-checkout" href="/">Continue shopping</a>`;
      return;
    }

    this.cartBody.innerHTML = `
      <ul class="bph-cart-items">
        ${cart.items.map((item) => this.renderCartItem(item)).join('')}
      </ul>
    `;

    if (cartExtras) {
      cartExtras.hidden = false;
      this.cartBody.appendChild(cartExtras);
    }

    this.cartFooter.innerHTML = `
      <div class="bph-cart-subtotal">
        <span>Subtotal</span>
        <span>${this.formatMoney(cart.total_price, cart.currency)}</span>
      </div>
      <p class="bph-cart-note">Shipping and discounts are calculated at checkout.</p>
      <a class="bph-cart-checkout" href="/checkout">Checkout</a>
    `;

    this.enhanceCartComparePrices(cart.items);
  }

  renderCartItem(item) {
    const image = item.image
      ? `<img src="${this.escapeHTML(item.image)}" alt="${this.escapeHTML(item.product_title || item.title || '')}" loading="lazy" width="auto" height="auto">`
      : '';
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const productHandle = this.getProductHandleFromCartItem(item);
    const variantId = Number(item.variant_id || item.id || 0);
    const quantity = Number(item.quantity) || 1;
    const saleLinePrice = Number(item.final_line_price || item.line_price || 0);
    const propertyComparePrice =
      item.properties && item.properties._compare_at_price ? Number(item.properties._compare_at_price) * quantity : 0;
    const originalLinePrice = Number(item.original_line_price || 0);
    const compareLinePrice =
      propertyComparePrice > saleLinePrice
        ? propertyComparePrice
        : originalLinePrice > saleLinePrice
          ? originalLinePrice
          : 0;
    const priceStackAttributes = `data-bph-cart-price-stack data-line-key="${this.escapeHTML(item.key)}" data-line-final-price="${saleLinePrice}" data-line-quantity="${quantity}" data-variant-id="${variantId}" data-product-handle="${this.escapeHTML(productHandle)}"`;
    const priceMarkup = compareLinePrice
      ? `<span class="bph-cart-price-stack" ${priceStackAttributes}><span class="bph-cart-compare-price">${this.formatMoney(compareLinePrice, this.cartCurrency)}</span><span class="bph-cart-sale-price">${this.formatMoney(saleLinePrice, this.cartCurrency)}</span></span>`
      : `<span class="bph-cart-price-stack" ${priceStackAttributes}><span class="bph-cart-sale-price">${this.formatMoney(saleLinePrice, this.cartCurrency)}</span></span>`;

    return `
      <li class="bph-cart-item" data-line-key="${this.escapeHTML(item.key)}" data-line-quantity="${Number(item.quantity) || 0}" data-variant-id="${variantId}" data-product-handle="${this.escapeHTML(productHandle)}">
        <a class="bph-cart-image" href="${this.escapeHTML(item.url || '/cart')}">${image}</a>
        <div class="bph-cart-info">
          <div class="bph-cart-line-top">
            <a class="bph-cart-product-title" href="${this.escapeHTML(item.url || '/cart')}">${this.escapeHTML(item.product_title || item.title || 'Product')}</a>
            ${priceMarkup}
          </div>
          ${variantTitle ? `<div class="bph-cart-meta">${this.escapeHTML(variantTitle)}</div>` : ''}
          <div class="bph-cart-line-bottom">
            <div class="bph-cart-qty" aria-label="Quantity">
              <button type="button" aria-label="Decrease quantity" data-bph-cart-qty="minus" data-line-key="${this.escapeHTML(item.key)}">-</button>
              <span>${Number(item.quantity) || 0}</span>
              <button type="button" aria-label="Increase quantity" data-bph-cart-qty="plus" data-line-key="${this.escapeHTML(item.key)}">+</button>
            </div>
            <button type="button" class="bph-cart-remove" data-bph-cart-remove data-line-key="${this.escapeHTML(item.key)}">Remove</button>
          </div>
        </div>
      </li>
    `;
  }

  getProductHandleFromCartItem(item) {
    if (item.handle) return String(item.handle);

    const url = String(item.url || '');
    const match = url.match(/\/products\/([^/?#]+)/);

    return match ? decodeURIComponent(match[1]) : '';
  }

  fetchProductJson(handle) {
    if (!handle || !window.fetch) return Promise.resolve(null);

    this.productJsonCache = this.productJsonCache || {};

    if (!this.productJsonCache[handle]) {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      const url = `${root}products/${encodeURIComponent(handle)}.js`;

      this.productJsonCache[handle] = fetch(url, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null);
    }

    return this.productJsonCache[handle];
  }

  enhanceCartComparePrices(items) {
    if (!items || !items.length) return;

    const lineItems = items
      .map((item) => {
        const quantity = Number(item.quantity) || 1;
        const saleLinePrice = Number(item.final_line_price || item.line_price || 0);
        const propertyCompareLinePrice =
          item.properties && item.properties._compare_at_price ? Number(item.properties._compare_at_price) * quantity : 0;
        const originalLinePrice = Number(item.original_line_price || 0);

        return {
          key: String(item.key || ''),
          handle: this.getProductHandleFromCartItem(item),
          variantId: Number(item.variant_id || item.id || 0),
          quantity,
          saleLinePrice,
          compareLinePrice: Math.max(propertyCompareLinePrice, originalLinePrice > saleLinePrice ? originalLinePrice : 0)
        };
      })
      .filter((item) => item.handle && item.variantId);

    const handles = Array.from(new Set(lineItems.map((item) => item.handle)));

    Promise.all(handles.map((handle) => this.fetchProductJson(handle))).then((products) => {
      const productByHandle = new Map();

      products.forEach((product, index) => {
        if (product) {
          productByHandle.set(handles[index], product);
        }
      });

      lineItems.forEach((lineItem) => {
        const product = productByHandle.get(lineItem.handle);
        const variant = product && product.variants ? product.variants.find((candidate) => Number(candidate.id) === lineItem.variantId) : null;
        const fetchedCompareLinePrice =
          variant && Number(variant.compare_at_price) > Number(variant.price)
            ? Number(variant.compare_at_price) * lineItem.quantity
            : 0;
        const compareLinePrice = Math.max(lineItem.compareLinePrice, fetchedCompareLinePrice);
        const priceStack = Array.from(this.querySelectorAll('[data-bph-cart-price-stack]')).find(
          (element) => element.dataset.lineKey === lineItem.key
        );

        if (!priceStack) return;

        if (compareLinePrice > lineItem.saleLinePrice) {
          priceStack.innerHTML = `<span class="bph-cart-compare-price">${this.formatMoney(compareLinePrice, this.cartCurrency)}</span><span class="bph-cart-sale-price">${this.formatMoney(lineItem.saleLinePrice, this.cartCurrency)}</span>`;
        } else {
          priceStack.innerHTML = `<span class="bph-cart-sale-price">${this.formatMoney(lineItem.saleLinePrice, this.cartCurrency)}</span>`;
        }
      });
    });
  }

  renderEmptyCart() {
    return `
      <div class="bph-cart-empty">
        <svg class="bph-svg bph-cart-svg" aria-hidden="true" viewBox="0 0 24 24">
          <path d="M16 8H17.1597C18.1999 8 19.0664 8.79732 19.1528 9.83391L19.8195 17.8339C19.9167 18.9999 18.9965 20 17.8264 20H6.1736C5.00352 20 4.08334 18.9999 4.18051 17.8339L4.84718 9.83391C4.93356 8.79732 5.80009 8 6.84027 8H8M16 8H8M16 8L16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7L8 8M16 8L16 12M8 8L8 12"></path>
          <text class="bph-cart-brand" x="12" y="15.4" text-anchor="middle">pehchaan</text>
        </svg>
        <strong>Your cart is empty</strong>
        <span>Start adding your favourites.</span>
      </div>
    `;
  }

  onCartActionClick(event) {
    const recommendationSlideButton = event.target.closest('[data-bph-recommend-slide]');
    const quantityButton = event.target.closest('[data-bph-cart-qty]');
    const removeButton = event.target.closest('[data-bph-cart-remove]');

    if (recommendationSlideButton) {
      event.preventDefault();
      const row = this.querySelector('[data-bph-recommend-row]');

      if (row) {
        const direction = recommendationSlideButton.dataset.bphRecommendSlide === 'prev' ? -1 : 1;
        row.scrollBy({
          left: direction * Math.max(row.clientWidth * 0.75, 120),
          behavior: 'smooth'
        });
      }

      return;
    }

    if (!quantityButton && !removeButton) return;

    event.preventDefault();
    const lineKey = (quantityButton || removeButton).dataset.lineKey;
    const lineItem = (quantityButton || removeButton).closest('[data-line-quantity]');
    const currentQuantity = Number(lineItem ? lineItem.dataset.lineQuantity : 0) || 0;
    const nextQuantity = removeButton
      ? 0
      : quantityButton.dataset.bphCartQty === 'plus'
        ? currentQuantity + 1
        : Math.max(currentQuantity - 1, 0);

    if (lineKey) {
      this.changeCartLine(lineKey, nextQuantity);
    }
  }

  onCartActionSubmit(event) {
    const recommendationForm = event.target.closest('[data-bph-recommendation-form]');

    if (recommendationForm) {
      event.preventDefault();
      this.addRecommendedProduct(recommendationForm);
    }
  }

  addRecommendedProduct(form) {
    const submitButton = form.querySelector('button[type="submit"]');
    const originalLabel = submitButton ? submitButton.textContent : '';

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Adding';
    }

    this.classList.add('is-cart-loading');

    fetch(form.action, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(form)
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add product');
        return fetch(this.getCartJsonUrl(), {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        });
      })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) {
          this.updateCart(cart);
        }
      })
      .finally(() => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }

        this.classList.remove('is-cart-loading');
      });
  }

  changeCartLine(lineKey, quantity) {
    this.classList.add('is-cart-loading');

    fetch(this.getCartChangeUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity
      })
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) {
          this.updateCart(cart);
        }
      })
      .finally(() => {
        this.classList.remove('is-cart-loading');
      });
  }

  formatMoney(cents, currency) {
    const amount = (Number(cents) || 0) / 100;
    const currencyCode = currency || this.cartCurrency || 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  installCartHooks() {
    if (window.__bonkersPremiumHeaderCartHooksInstalled) return;
    window.__bonkersPremiumHeaderCartHooksInstalled = true;

    const isCartRequest = (resource) => {
      const url = typeof resource === 'string' ? resource : resource && resource.url;
      if (!url) return false;

      try {
        const parsedUrl = new URL(url, window.location.origin);
        return /\/cart\/(add|change|update|clear)(\.js)?$/.test(parsedUrl.pathname);
      } catch (error) {
        return /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url));
      }
    };

    const dispatchCartRefresh = () => {
      window.clearTimeout(window.__bonkersPremiumHeaderCartRefreshTimer);
      window.__bonkersPremiumHeaderCartRefreshTimer = window.setTimeout(() => {
        document.dispatchEvent(new CustomEvent('bonkers:cart-refresh'));
      }, 140);
    };

    if (window.fetch) {
      const originalFetch = window.fetch;
      window.fetch = function (...args) {
        const resource = args[0];

        return originalFetch.apply(this, args).then((response) => {
          if (response && response.ok && isCartRequest(resource)) {
            dispatchCartRefresh();
          }

          return response;
        });
      };
    }

    if (window.XMLHttpRequest) {
      const originalOpen = window.XMLHttpRequest.prototype.open;
      const originalSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url, ...args) {
        this.__bphCartUrl = url;
        return originalOpen.call(this, method, url, ...args);
      };

      window.XMLHttpRequest.prototype.send = function (...args) {
        if (isCartRequest(this.__bphCartUrl)) {
          this.addEventListener(
            'loadend',
            () => {
              if (this.status >= 200 && this.status < 400) {
                dispatchCartRefresh();
              }
            },
            { once: true }
          );
        }

        return originalSend.apply(this, args);
      };
    }

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (form instanceof HTMLFormElement && isCartRequest(form.action)) {
          window.setTimeout(dispatchCartRefresh, 900);
        }
      },
      true
    );
  }

  onScroll() {
    if (this.scrollTicking) return;

    window.requestAnimationFrame(() => {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > this.lastScrollY;
      const pastHeader = currentScrollY > this.offsetHeight;

      this.classList.toggle('is-compact', this.stickyType === 'reduce-logo-size' && pastHeader);
      this.updateTransparentState();

      if (this.stickyType === 'on-scroll-up') {
        this.classList.toggle(
          'is-hidden',
          isScrollingDown &&
            pastHeader &&
            !this.classList.contains('is-drawer-open') &&
            !this.classList.contains('is-search-open') &&
            !this.classList.contains('is-cart-open')
        );
      }

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.classList.remove('is-hidden');
      }

      this.lastScrollY = Math.max(currentScrollY, 0);
      this.scrollTicking = false;
    });

    this.scrollTicking = true;
  }
}

if (!customElements.get('bonkers-premium-header')) {
  customElements.define('bonkers-premium-header', BonkersPremiumHeader);
}
